import PropTypes from 'prop-types';
import { Spinner } from 'reactstrap';

const Loader = ({ fixed, isWrapper = true }) =>
  isWrapper ? (
    <div className={['loader-wrapper', fixed === 'no' ? 'no-fixed' : null].join(' ')}>
      <Spinner color="primary">loading...</Spinner>
    </div>
  ) : (
    <Spinner color="primary">loading...</Spinner>
  );

Loader.propTypes = {
  fixed: PropTypes.oneOf(['no', null]),
  isWrapper: PropTypes.bool,
};
Loader.defaultProps = {
  fixed: null,
  isWrapper: true,
};

export { Loader };
export default Loader;
